import httpClient from 'shared/lib/httpClient';

export const submitTariffBook = async (id) => {
  const response = await httpClient.post(`/tariff-books/${id}/submit`);
  return response?.data;
};
